import React, { useEffect, useState } from 'react';
import './newarticles.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { addDoc, collection, getDocs, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { Link, useNavigate } from 'react-router-dom';
import { BsCheck2Circle } from 'react-icons/bs';
import { FaAnglesLeft } from 'react-icons/fa6';
import { auth, db, storage } from '../../../firebase';
import Modal from '../../../components/Modal/Modal';
import { BiXCircle } from 'react-icons/bi';

const quillModules = {
    toolbar: [
        [{ 'font': [] }],
        [{ size: [] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' },
        { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image', 'video'],
        ['clean']
    ]
};

const quillFormats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video'
];

function NewArticle() {

    const [title, setTitle] = useState('');
    const [author, setAuthor] = useState('');
    const [cover, setCover] = useState('');
    const [content, setContent] = useState('');
    const [rubriques, setRubriques] = useState([]);

    const user = auth.currentUser;
    //Récupérer les données de l'utilisateur
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            const q = query(collection(db, "users"),
                where("email", "==", user.email))
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                setUserData(doc.data());
            })
        };
        fetchUserData();
    }, [user]);

    const handleCover = (event) => {
        const file = event.target.files[0];
        if (file) {
            setCover({
                file,
                preview: URL.createObjectURL(file)
            });
        }
    };

    const removeCover = () => {
        setCover(null);
    };

    const handleChange = (newValue) => {
        setContent(newValue);
    };

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    }

    const [isLoading, setIsLoading] = useState(false);

    const addNewArticle = async (event) => {
        try {
            event.preventDefault();
            setIsLoading(true); // Afficher le loader

            // Vérification du fichier
            if (!cover || !cover.file) throw new Error("Aucune image de couverture sélectionnée");

            // Générer un nom unique basé sur le titre
            const timestamp = Date.now();
            const extension = cover.file.name.split('.').pop();
            const customFileName = `article_${timestamp}.${extension}`;

            // Référence Firebase avec nom personnalisé
            const fileRef = ref(storage, `article_covers/${customFileName}`);

            // Upload
            await uploadBytes(fileRef, cover.file);

            // URL
            const coverUrl = await getDownloadURL(fileRef);

            // Ajout dans Firestore
            await addDoc(collection(db, "articles"), {
                title: title,
                titleLowerCase: title.toLowerCase(),
                author: author,
                coverUrl: coverUrl,
                rubriques: rubriques, // Tableau
                content: content,
                isVisible: false,
                createdAt: new Date(),
            });

            setIsLoading(false);
            setOpen(true);
            navigate(-1);
        } catch (error) {
            console.error("Error adding article: ", error.message);
            setIsLoading(false);
            // Afficher un message d’erreur au besoin
        }
    };


    const navigate = useNavigate();

    //read rubriques data
    const [rubriqueOptions, setRubriqueOptions] = useState([])
    useEffect(() => {
        const rubriqueOptionRef = query(collection(db, 'categories'), orderBy('nom', 'asc'))
        onSnapshot(rubriqueOptionRef, (snapshot) => {
            setRubriqueOptions(snapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        })
    }, [])

    //read authors data
    const [authors, setAuthors] = useState([])
    useEffect(() => {
        const authorsRef = query(collection(db, 'authors'))
        onSnapshot(authorsRef, (snapshot) => {
            setAuthors(snapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        })
    }, [])

    return (

        <div id='newArticle' className='px-[60px]'>

            <section className="flex pb-[30px]" id='blog'>

                <div className="xl:flex hidden justify-start items-center">
                    <Link onClick={() => navigate(-1)} className="font-pressura flex items-center text-aqua text-[14px]">
                        <FaAnglesLeft className='text-[10px]' />
                        Back
                    </Link>
                </div>

            </section>

            <div className='flex justify-center w-full'>

                <form className='font-agrandir w-full' onSubmit={addNewArticle}>

                    <div className='form-ctrl'>
                        <label className='text-white'><p>Titre</p></label>
                        <input type="text"
                            className='outline-none border-2 px-4 py-2 rounded-md w-full'
                            value={title}
                            onChange={(event) => setTitle(event.target.value)}
                            required
                        />
                    </div>

                    <div className='form-ctrl'>
                        <label className='text-white'><p>Auteur</p></label>
                        <select
                            value={author}
                            onChange={(e) => setAuthor(e.target.value)}
                            required>
                            <option >-Sélectionner l'auteur de cet article-</option>
                            {authors.map((auth) => {
                                return (
                                    <option key={auth.id} value={auth.id} className=''>
                                        {auth.data.displayName}
                                    </option>
                                )
                            })}
                        </select>
                    </div>

                    <div className="my-10">
                        <label className='text-white'>Photo de couverture</label>

                        <div className="relative border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-purple-500 transition-all">
                            <input
                                type="file"
                                onChange={handleCover}
                                accept="image/*"
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                            />
                            <p className="text-gray-500">Cliquez ou glissez une image ici</p>
                        </div>

                        {/* Preview de la cover */}
                        {cover && (
                            <div className="relative mt-4 w-full max-w-md mx-auto">
                                <img
                                    src={cover.preview}
                                    alt="Cover preview"
                                    className="w-full rounded-lg shadow-lg object-cover"
                                />
                                <button
                                    onClick={removeCover}
                                    className="absolute top-2 right-2 bg-red-500 text-white p-1.5 rounded-full shadow-lg hover:bg-red-600 transition"
                                >
                                    <BiXCircle size={20} />
                                </button>
                            </div>
                        )}
                    </div>

                    <div className='form-ctrl'>
                        <label className='text-white'><p className=''>Catégories</p></label>
                        <div className="flex flex-wrap gap-3">
                            {rubriqueOptions.map((rubriqueOption) => {
                                const rubriqueName = rubriqueOption.data.nom;
                                return (
                                    <label key={rubriqueOption.id} className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            type="checkbox"
                                            value={rubriqueName}
                                            checked={rubriques.includes(rubriqueName)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setRubriques([...rubriques, rubriqueName]);
                                                } else {
                                                    setRubriques(rubriques.filter(item => item !== rubriqueName));
                                                }
                                            }}
                                            className="w-4 h-4 accent-purple-600"
                                        />
                                        <span className=" text-white">{rubriqueName}</span>
                                    </label>
                                );
                            })}
                        </div>
                    </div>

                    <div className='form-ctrl text-white'>
                        <label className='text-white'>Ecrivez votre article</label>
                        <ReactQuill
                            value={content}
                            onChange={handleChange}
                            modules={quillModules}
                            formats={quillFormats}
                        />
                    </div>

                    <div className='btn-ctrl'>
                        <button className="buttonviolet w-[200px!important]">
                            {isLoading ? (
                                <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            ) : (
                                <p>Publier l'article</p>
                            )}
                        </button>
                    </div>

                </form>

            </div>

            {open &&
                <Modal isOpen={open} onClose={handleClose}>
                    <center>
                        <div className='flex flex-col gap-4 items-center justify-center'>
                            <BsCheck2Circle className='text-green-700 text-[50px]' />

                            <p>Votre article a bien été publié !</p>

                            <button
                                className='buttonviolet'
                                type='submit'
                                onClick={handleClose}
                            >OK</button>

                        </div>
                    </center>
                </Modal>
            }

        </div>

    )
}

export default NewArticle